import { ExperienceTemplateStatus } from '@dadohr/shared/domainTypes/experience';
import assertNever from 'assert-never';
import { Color, ColoredChipDark } from '../../../../components/ColoredChip';
import { TFunction, useTranslation } from '../../../../i18next';

const getConfig = (
  status: ExperienceTemplateStatus,
  t: TFunction
): [string, Color] | null => {
  switch (status) {
    case ExperienceTemplateStatus.ACTIVE:
      return [t('template.status.active'), 'green'];
    case ExperienceTemplateStatus.INACTIVE:
      return [t('template.status.inactive'), 'yellow'];
    case ExperienceTemplateStatus.ROUGH_DRAFT:
    case ExperienceTemplateStatus.DRAFT:
      return [t('template.status.draft'), 'gray'];
    case ExperienceTemplateStatus.ARCHIVED:
      return [t('template.status.archived'), 'black'];
    default:
      return assertNever(status);
  }
};

export const TemplateStatusChip = ({
  status,
  size
}: {
  status: ExperienceTemplateStatus;
  size?: 'medium' | 'small';
}) => {
  const { t } = useTranslation();
  const config = getConfig(status, t);
  if (!config) return null;
  const [label, color] = config;
  return (
    <ColoredChipDark size={size} color={color}>
      {label}
    </ColoredChipDark>
  );
};
